import React from 'react';
import { useSelector } from 'react-redux';
import { getChipFeedState } from '../store/selectors/chipFeedSelector';
import ChipFeed from '../ChipFeed';
import initContainerData from 'bdata-react-component/lib/store/initContainerData';
import chipFeedReducer from '../store/reducers/chipFeed';
import { getCommercialBreakState } from '../../Ads/store/selectors/commercialBreak';
import usePlayTimer from '@gameday/utils/hooks/usePlayTimer';

initContainerData.register({
    reducers: {
        chipFeed: chipFeedReducer
    }
});

const ChipFeedDataContainer = () => {
    const chipFeedState = useSelector(getChipFeedState);
    const { showMidInnigAd, adStarted } = useSelector(getCommercialBreakState);
    const { adjusted } = usePlayTimer();

    if (adjusted && showMidInnigAd && adStarted) {
        return null;
    }

    return (
        <ChipFeed { ...chipFeedState } />
    );
};

export default ChipFeedDataContainer;
